import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { useParams } from "react-router";

import { useStaffCustomer } from "@/components/helpers/custom-hooks/use-staff-customer";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { ClientNav } from "@/components/pages_logged_in/workspace/ClientNav/ClientNav";
import {
  ClientWorkspaceProvider,
  useClientWorkspaceContext,
} from "@/components/pages_logged_in/workspace/clients/ClientWorkspaceContext";
import { ChatChannel } from "@/components/pages_logged_in/workspace/messages/ChatChannel";
import { ClientChannelList } from "@/components/pages_logged_in/workspace/messages/ClientChannelList";
import { EmptyState } from "@/components/pages_logged_in/workspace/messages/EmptyState";
import { SIDE_NAV_WIDTH, STANDARD_APP_MAX_WIDTH } from "@/css/constants";
import { useHasChatChannelsQuery } from "@/graphql";

function MessagesContent({ customerId }: { customerId?: string }) {
  const { userId, channelId } = useParams();
  const { data } = useHasChatChannelsQuery({ variables: { customerId } });

  if ((!data || data?.hasChatChannels) && userId) {
    return (
      <>
        <Media greaterThan="xs">
          <Flex style={{ maxWidth: STANDARD_APP_MAX_WIDTH }}>
            <ClientChannelList customerId={userId} onMessageRead={() => null} />
            {channelId ? (
              <ChatChannel
                key={channelId}
                customerId={userId}
                channelId={channelId}
              />
            ) : null}
          </Flex>
        </Media>

        <Media at="xs">
          {channelId ? (
            <ChatChannel
              key={channelId}
              customerId={userId}
              channelId={channelId}
              backLinkTo={`/client/${userId}/messages`}
            />
          ) : (
            <ClientChannelList customerId={userId} onMessageRead={() => null} />
          )}
        </Media>
      </>
    );
  }
  return (
    <Box>
      <Container justifyContent="space-around" flexWrap="wrap">
        <Box mt={4} pt={3} mb={3} px={2} maxWidth="100%">
          <EmptyState isCoach={false} />
        </Box>
      </Container>
    </Box>
  );
}

const Container = styled(Flex)`
  min-height: 100vh;
  padding-top: 100px;
  background-color: ${Colors.WHITE};
`;

export function AuthWorkspaceMessages() {
  const { userId } = useParams();
  const { currentWorkspaceId, workspaces, onSelectWorkspace } =
    useClientWorkspaceContext();
  const { data } = useStaffCustomer({ userId, currentWorkspaceId });

  return (
    <>
      <Nav />
      <Box ml={[0, 0, SIDE_NAV_WIDTH]}>
        <ClientNav
          client={data?.customer}
          currentWorkspaceId={currentWorkspaceId}
          workspaces={workspaces}
          onSelectWorkspace={onSelectWorkspace}
        />
        <MessagesContent customerId={data?.customer?.id} />
      </Box>
    </>
  );
}

export function WorkspaceMessagesPage() {
  const { userId } = useParams();
  return (
    <Authenticate layout="dashboard" maxWidth="100%">
      <ClientWorkspaceProvider clientId={userId || ""}>
        <AuthWorkspaceMessages />
      </ClientWorkspaceProvider>
    </Authenticate>
  );
}
